module.exports = __webpack_public_path__ + "static/media/logo.089706e8.png";